import { fetchSubscription, fetchUserTYpes } from "../../Api/SignupApi";
import { fetchPlansFailure, fetchPlansStart, fetchPlansSuccess } from "../Slices/subscriptionSlice";
import { fetchUserTypesFailure, fetchUserTypesStart, fetchUserTypesSuccess } from "../Slices/userTypeSlice";
import { AppDispatch } from "../Store";

export const fetchUserTypes = () => async (dispatch: AppDispatch) => {
    try {
        dispatch(fetchUserTypesStart());
        const response = await fetchUserTYpes();
        if (response.status) {
            dispatch(fetchUserTypesSuccess(response.body || []));
        } else {
            dispatch(fetchUserTypesFailure(response.error!.toString() || ''));
        }

    } catch (error) {
        dispatch(fetchUserTypesFailure(error!.toString() || ''));
    }
}

export const fetchPlans = () => async (dispatch: AppDispatch) => {
    try {
        dispatch(fetchPlansStart());
        const response = await fetchSubscription();
        if (response.status) {
            dispatch(fetchPlansSuccess(response.body || []));
        } else {
            dispatch(fetchPlansFailure(response.error!.toString() || ''));
        }

    } catch (error) {
        dispatch(fetchPlansFailure(error!.toString()));
    }
};